import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ShipmentTariffTab from './components/ShipmentTariffTab';
import BoxCategoryTab from './components/BoxCategoryTab';
import BoxTypeTab from './components/BoxTypeTab';
import BoxVolumeTab from './components/BoxVolumeTab';
import BoxWeightTab from './components/BoxWeightTab';
import CancellationPolicyTab from './components/CancellationPolicyTab';

const PAGE_TITLE = 'shipmentManagementPage_Title';

export default function ShipmentManagementPage() {
  const { t } = useTranslation();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('shipmentManagementPage_ShipmentTariffs')} key={'tariffs'}>
            <ShipmentTariffTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('shipmentManagementPage_CancellationPolicy')} key={'cancellation-policy'}>
            <CancellationPolicyTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('shipmentManagementPage_BoxCategory')} key={'box-category'}>
            <BoxCategoryTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('shipmentManagementPage_BoxType')} key={'box-type'}>
            <BoxTypeTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('shipmentManagementPage_BoxVolume')} key={'box-volume'}>
            <BoxVolumeTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('shipmentManagementPage_BoxWeight')} key={'box-weight'}>
            <BoxWeightTab />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
